import { render, staticRenderFns } from "./sales-approval.vue?vue&type=template&id=8e52ea4c&scoped=true"
import script from "./sales-approval.vue?vue&type=script&lang=ts"
export * from "./sales-approval.vue?vue&type=script&lang=ts"
import style0 from "./sales-approval.vue?vue&type=style&index=0&id=8e52ea4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e52ea4c",
  null
  
)

export default component.exports